import { Card, PrimaryButton, OutlineButton, PopupDialogbox, Table, Accordion, EventHandler } from '../../../../CommonComponents';
import ArrowDown from '../../../../assets/images/arrowDown.png'
import ArrowUp from '../../../../assets/images/arrowUp.png'
import './LeadrOrder.scss'
import OrderDetail from "../../ApprovalOrder/LeadrOrder/OrderDetail";
import Moment from 'moment';
import permissions, { ACCESS_DENIED, isAuthorized } from 'client/utils/Permissions';
import Attachment from './Attachment';
import { CONSTANTS } from 'client/utils/constants';
import AttachmentLinkContainer from '../../ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink/AttachmentLink-Container';

interface IProps {
    orderByIdValue?: any,
    handleClickOrder?: any,
    cancelOrderReq?: any,
    Popupcontent?: any,
    hideDialog?: any,
    popupOutlinebtnOnclick?: any,
    popupPrimarybtnOnclick?: any,
    collapse?: any;
    onExpand?: any;
    expenditureData?: any;
    expenditureColumn?: any;
    activeRow?: any;
    userDetails?: any;
    setValue?: any,
    createdDateval?: any,
    isBulkOrder?: boolean,
    getUserRoles?: any
}
const LeaderOrder = ({ createdDateval, setValue, orderByIdValue, handleClickOrder, cancelOrderReq, Popupcontent, hideDialog, activeRow,
    userDetails, popupOutlinebtnOnclick, popupPrimarybtnOnclick, collapse, onExpand, expenditureData, expenditureColumn, isBulkOrder,getUserRoles }: IProps) => {

    const cancelOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Order</p>
            <p>
                <b>LEADR Order # : </b>{orderByIdValue?.orderId}
            </p>
        </>
    );

    const editOrderButton = () => {        
        if ((isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.RequisitionsView)) && orderByIdValue?.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase() && !isBulkOrder) {
            return <OutlineButton disabled={(!isAuthorized(permissions.RequisitionsCreateUpdate) && !isAuthorized(permissions.RequisitionsView)) || orderByIdValue?.createdBy?.toLowerCase() !== userDetails?.emailId.toLowerCase()} text='Edit' className='pull-right me-0' onClick={() => handleClickOrder(orderByIdValue)} title={(isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.RequisitionsView)) && orderByIdValue.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase() ? "Edit Order" : ACCESS_DENIED}  data-attribute="LeadrOrder_Default_Button_3" />
        } else if ((isAuthorized(permissions.CreateUpdateBulkOrder) || isAuthorized(permissions.ViewBulkOrder)) && orderByIdValue?.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase() && isBulkOrder) {
            return <OutlineButton disabled={(!isAuthorized(permissions.CreateUpdateBulkOrder) && !isAuthorized(permissions.ViewBulkOrder)) || orderByIdValue?.createdBy?.toLowerCase() !== userDetails?.emailId.toLowerCase()} text='Edit' className='pull-right me-0' onClick={() => handleClickOrder(orderByIdValue)} title={(isAuthorized(permissions.CreateUpdateBulkOrder) || isAuthorized(permissions.ViewBulkOrder)) && orderByIdValue.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase() ? "Edit Order" : ACCESS_DENIED}  data-attribute="LeadrOrder_Default_Button_4" />
        } else {
            return null
        }
    }
    const cancelButton = () => {        
        if (((isAuthorized(permissions.RequisitionsDelete) || isAuthorized(permissions.RequisitionsView)) && orderByIdValue.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase() && !isBulkOrder && orderByIdValue?.orderStatus !== "Saved") || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) {
            return <OutlineButton disabled={(!(isAuthorized(permissions.RequisitionsDelete) || !isAuthorized(permissions.RequisitionsView) || orderByIdValue?.createdBy.toLowerCase() !== userDetails?.emailId.toLowerCase())) && !getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)} text='Cancel Order' className='pull-right' onClick={() => cancelOrderReq(cancelOrdersubtext)} title={((isAuthorized(permissions.RequisitionsDelete) && isAuthorized(permissions.RequisitionsView) && orderByIdValue.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase()) || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ? "Cancel Order" : ACCESS_DENIED}  data-attribute="LeadrOrder_Default_Button_5" />
        } else if (((isAuthorized(permissions.DeleteBulkOrder) || isAuthorized(permissions.ViewBulkOrder)) && orderByIdValue.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase() && isBulkOrder && orderByIdValue?.orderStatus !== "Saved") || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) {
            return <OutlineButton disabled={(!isAuthorized(permissions.DeleteBulkOrder) || !isAuthorized(permissions.ViewBulkOrder) || orderByIdValue?.createdBy.toLowerCase() !== userDetails?.emailId.toLowerCase()) && !getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)} text='Cancel Order' className='pull-right' onClick={() => cancelOrderReq(cancelOrdersubtext)} title={((isAuthorized(permissions.DeleteBulkOrder) && isAuthorized(permissions.ViewBulkOrder) && orderByIdValue.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase()) || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ? "Cancel Order" : ACCESS_DENIED}  data-attribute="LeadrOrder_Default_Button_6" />
        } else {
            return null;
        }
    }


    const ExpandedItems = [
        {
            headerText: (
                <div className='LeaderOrderHeader'>
                    <div className="leadrTitle leadrOrder">LEADR ORDER# - {orderByIdValue?.orderId}</div>
                    <div className="leadrHead">
                        <div className="orderRequestType">
                            <p className="label">Request Type</p>
                            <p>{isBulkOrder ? CONSTANTS.BULK_ORDER : CONSTANTS.REQUISITIONS}</p>
                        </div>
                        <div className="createdDate">
                            <p className="label">Created Date</p>
                            <p>{createdDateval()}</p>
                        </div>
                        <div className="updatedDate">
                            <p className="label">Updated Date</p>
                            <p>{orderByIdValue?.updatedDate ? Moment(orderByIdValue?.updatedDate).format('MM/DD/YYYY') : ''}</p>
                        </div>
                    </div>
                </div>
            ),
            content: <>
                <div className="p-3">
                    <div className="blueLabel pull-left">Request Details</div>
                    <div className='pull-right mb-2'>
                        {!isBulkOrder && <AttachmentLinkContainer
                            item={orderByIdValue}
                            itemLevel={"Order"}
                        />}
                    </div>
                    <OrderDetail />
                    <div className='captitalLeaseBlock mb-3'>
                        <div className='clearfix'>
                            <div className='capitalHeading float-left'>
                                <span>CAPITAL/LEASE EXPENDITURE DETAILS</span>
                                {
                                    collapse ? <EventHandler onEvent={onExpand} data-attribute="LeadrOrder_Default_EventHandler"><img src={ArrowUp} alt='arrowUp' /></EventHandler> : <EventHandler onEvent={onExpand} data-attribute="LeadrOrder_Default_EventHandler_2"><img src={ArrowDown} alt='arrowDown' /></EventHandler>
                                }
                            </div>
                            {
                                setValue == 1 ?
                                    <div className='pull-right'>
                                        <Attachment />
                                    </div> : null
                            }
                        </div>
                        {
                            collapse ? <div className='capitalLeaseTable'>
                                <Table
                                    data={expenditureData}
                                    column={expenditureColumn}
                                    className='capitalizeTable'
                                 data-attribute="LeadrOrder_Default_Table" />
                            </div> : null
                        }
                    </div>
                </div>
            </>,
            uuid: "Accordion1",
        }
    ];
    return <div className="LeaderOrderContainer customermyorder card-radius">
        <Card data-attribute="LeadrOrder_Default_Card_2">
            <Accordion
                Items={ExpandedItems}
                preExpanded={["Accordion1"]}
                className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
             data-attribute="LeadrOrder_Default_Accordion_2" />
            <div className='pull-right'>
                {
                    orderByIdValue?.orderStatus === "Returned to Requestor" || orderByIdValue?.orderStatus === "Returned" || orderByIdValue?.orderStatus === "Pending" || orderByIdValue?.orderStatus === "Pending Approval" || orderByIdValue?.orderStatus === "Saved" ?
                        <>
                            {
                                editOrderButton()
                            }
                            {
                                cancelButton()
                            }
                            {Popupcontent.isDialogVisible && <PopupDialogbox
                                hideDialog={!Popupcontent.isDialogVisible}
                                onDismiss={hideDialog}
                                Popupcontent={Popupcontent}
                                popupOutlinebtnOnclick={popupOutlinebtnOnclick}
                                popupPrimarybtnOnclick={(
                                    item: any,
                                    actionby: string,
                                    value: any
                                ) => {
                                    popupPrimarybtnOnclick(
                                        item,
                                        actionby,
                                        value
                                    );
                                }}
                             data-attribute="LeadrOrder_Default_PopupDilalogBox_2" />}

                        </>
                        : null
                }
            </div>
        </Card>
    </div>
}

export default LeaderOrder;
